import { createContext, PropsWithChildren, useContext } from 'react';

export type SiteConfigurationProviderProps = {
  readonly configuration: SiteConfiguration;
};

export type SiteConfiguration = {
  readonly [key: string]: string;
};

const SiteConfigurationContext = createContext<SiteConfiguration>({});

export function useSiteConfiguration(): SiteConfiguration {
  return useContext(SiteConfigurationContext);
}

export const SiteConfigurationProvider = (
  props: PropsWithChildren<SiteConfigurationProviderProps>
) => {
  return (
    <SiteConfigurationContext.Provider value={props.configuration}>
      {props.children}
    </SiteConfigurationContext.Provider>
  );
};
